import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../nodeInstance";
import { useState, useEffect, useCallback } from "react";
import { pdf } from "@react-pdf/renderer";
import Costplusimmediate from "./costplusimmediate";
import SecDepopsitImmediate from "./SecDeposit_Immediate";
import { setAppError } from "../../../../store/userSlice";
import Trigger from "./trigger";

export default function DownloadPopUp_VisaCost({
  downloadPopUp,
  setDownloadPopUp,
  downloadData,
  summaryProp,
  SetDownloadPDF,
}) {
  console.log("Data to be printed here..", downloadData, summaryProp);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [pdfData, setPdfData] = useState(null); // Store the PDF data here
  const [pdfName, setPdfName] = useState(""); // Store the name of the PDF
  const [downloadUrl, setDownloadUrl] = useState(""); // Store the download URL

  // Effect to handle button disabling when popup is open
  useEffect(() => {
    if (downloadPopUp) {
      setIsButtonDisabled(true); // Disable buttons when popup is open
      const timer = setTimeout(() => {
        setIsButtonDisabled(false); // Enable buttons after 3 seconds
      }, 3000);

      return () => clearTimeout(timer);
    } else {
      // Reset states and trigger re-render when popup is closed
      setPdfData(null); // Clear PDF data
      setDownloadUrl(""); // Clear download URL
    }
  }, [downloadPopUp]);

  const downloadPaymentReceipt = async (value) => {
    try {
      const token = localStorage.getItem("nodeToken");
      const response = await nodeinstance.get(
        `/dashboard/visaSecurity/downloadZipBySummaryId/${downloadData?.contract_id}/${downloadData.id}/${value}`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response", response);
      if (response.status === 200) {
        const contentType = response.headers["content-type"];
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${value}_INVOICE.zip`);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url); // Clear blob URL to free memory
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };

  const [data, setData] = useState([]);

  // Data sets for 2 rows and 10 rows
  let smallData = [
    {
      Header: "Invoice details.",
      value: "",
      Artabic: "تفاصيل الفاتـــــــــــــورة",
    },
    {
      Header: "Request Date",
      value: new Date()
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        .split(" ")
        .join("-")
        .toUpperCase(),
      Artabic: "تاريخ الفاتورة الأولية",
    },
    {
      Header: "Invoice No.",
      value: downloadData.invoice_number || "",
      Artabic: "رقم الفاتورة الأولية",
    },
    {
      Header: "Contract Number #",
      value: (summaryProp && summaryProp[0].contract_number) || "",
      Artabic: "رقم العقد",
    },
    {
      Header: `${downloadData.months} months Security Deposit for ${downloadData.quantity} candidates`,
      value: downloadData.invoice_amount,
      Artabic: "وديعة تأمين لمدة شهر لـ <XX> مرشح",
    },
    {
      Header: "Total Amount",
      value: downloadData.invoice_amount,
      Artabic: "المبلغ الإجمالي",
    },
  ];
  let largeData = [
    {
      Header: "Invoice details.",
      value: "",
      Artabic: "تفاصيل الفاتـــــــــــــورة",
    },
    {
      Header: "Request Date",
      value: new Date()
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        .split(" ")
        .join("-")
        .toUpperCase(),
      Artabic: "تاريخ اصدار الفاتورة",
    },
    {
      Header: "Invoice No.",
      value: downloadData?.invoice_number || "",
      Artabic: "رقم الفاتورة",
    },
    {
      Header: "Invoice for",
      value: "VISA COST",
      Artabic: "فاتورة الخدمات المنفذة فى شهر",
    },
    {
      Header: "Customer VAT Number",
      value: summaryProp && summaryProp[0]?.vat_number,
      Artabic: "الرقــم الضريبــى للعميل",
    },
    {
      Header: "Contract Number #",
      value: summaryProp && summaryProp[0]?.contract_number,
      Artabic: "رقم العقد",
    },
    {
      Header: "Taxable amount Service charges",
      value:
        parseInt(downloadData.invoice_amount) -
        parseInt(downloadData.Vat_Amount),
      Artabic: "مبلغ خاضع للضريبة",
    },
    {
      Header: "Non-Taxable Amount - SAR",
      value: "",
      Artabic: "مبلغ غير خاضع للضريبة",
    },
    {
      Header: "VAT Amount 15% - SAR",
      value: downloadData.Vat_Amount,
      Artabic: "15قيمة الضريبة%",
    },
    {
      Header: "Total Invoice Amount - SAR",
      value: downloadData.invoice_amount,
      Artabic: "المبلغ الأجمالى للفاتورة",
    },
    {
      Header: "VAT # for Soundlines Administrative Co",
      value: summaryProp && summaryProp[0].Company_vat_number,
      Artabic: "لرقم الضريبى لشركة ساوندلاينز الإداريه",
    },
  ];

  const Checkkkkkkkkk = [
    {
      type: "VISA COST",
      employees: [
        { employeeName: "John", jobTitle: "Manager", salary: 5000, age: 30 },
      ],
    },
    {
      type: "SEC DEPOSIT",
      employees: [
        { employeeName: "Doe", jobTitle: "Engineer", salary: 4000, age: 25 },
      ],
    },
  ];

  const generatePDF = useCallback(async (data, name) => {
    setData(data);
    setPdfName(name);

    try {
      const blob = await pdf(
        <Costplusimmediate
          data={data}
          valueChange={downloadData}
          clientDetails={summaryProp}
          header={name}
        />
      ).toBlob();
      const url = URL.createObjectURL(blob);
      setDownloadUrl(url); // Set the download URL

      // Optional: Automatically click to download (depending on how you want to handle)
      const link = document.createElement("a");
      link.href = url;
      link.download = name;
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      URL.revokeObjectURL(url); // Clean up
    } catch (error) {
      console.error("Error generating PDF", error);
    }
  }, []);

  const generateSmallPDF = (name) => {
    generatePDF(smallData, `${name}`);
  };

  const generateLargePDF = (name) => {
    generatePDF(largeData, `${name}`);
  };

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
        downloadPopUp ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-lg w-full h-[250px] overflow-auto rounded-md bg-white/95 flex flex-col p-4 relative">
        <div className="flex justify-between items-center w-full">
          <h1
            className="text-md font-semibold cursor-pointer"
            onClick={() => {
              setDownloadPopUp(false);
            }}
          >
            <IoMdClose />
          </h1>
        </div>
        {downloadData.cost_type === "VISA COST" ? (
          <>
            <div className="flex items-center justify-between mt-4">
              <label htmlFor="" className="px-1">
                Generate Proforma Invoice
              </label>
              <div className="flex space-x-2">
                <button
                  onClick={() => generateLargePDF("PROFORMA INVOICE")}
                  className="px-4 py-2 bg-blue text-white rounded"
                  disabled={isButtonDisabled}
                >
                  Download
                </button>
              </div>
            </div>
            <div className="flex items-center justify-between mt-4">
              <label htmlFor="" className="px-1">
                Generate Invoice
              </label>
              <div className="flex space-x-2">
                <button
                  onClick={() => generateLargePDF("INVOICE")}
                  className="px-4 py-2 bg-blue text-white rounded"
                  disabled={isButtonDisabled}
                >
                  Download
                </button>
              </div>
            </div>
          </>
        ) : (
          <div className="flex items-center justify-between mt-4">
            <label htmlFor="" className="px-1">
              Sec Deposit
            </label>
            <div className="flex space-x-2">
              <button
                onClick={() => generateSmallPDF("REQUEST FOR SECURITY DEPOSIT")}
                className="px-4 py-2 bg-blue text-white rounded"
                disabled={isButtonDisabled}
              >
                Download
              </button>
            </div>
          </div>
        )}
        {downloadUrl && (
          <div className="mt-4">
            <a href={downloadUrl} download={pdfName} className="hidden">
              Download PDF
            </a>
          </div>
        )}
        <div className="flex items-center justify-between mt-4">
          <div>
            <label htmlFor="" className="px-1">
              Download TAX Invoice:
            </label>
          </div>
          <div>
            <button
              className={`p-2 px-4 rounded-md ${
                isButtonDisabled ? "bg-gray-400" : "bg-blue"
              } text-white min-w-fit text-sm flex items-center gap-2`}
              style={{ pointerEvents: isButtonDisabled ? "none" : "auto" }}
              onClick={() => {
                downloadPaymentReceipt("TAX");
              }}
            >
              Download
            </button>
          </div>
        </div>

        <div className="flex items-center justify-between mt-4">
          <div>
            <label htmlFor="" className="px-1">
              Download PAYMENT RECEIPT:
            </label>
          </div>
          <div>
            <button
              className={`p-2 px-4 rounded-md ${
                isButtonDisabled ? "bg-gray-400" : "bg-blue"
              } text-white min-w-fit text-sm flex items-center gap-2`}
              style={{ pointerEvents: isButtonDisabled ? "none" : "auto" }}
              onClick={() => {
                downloadPaymentReceipt("PAYMENT");
              }}
            >
              Download
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
